import React from 'react';
import cn from 'classnames';
import FillPreview from 'admin/components/pages/Story/CardEditor/Inspector/PropField/FillPreview';
import css from './ColorPicker.scss';

type Props = {
	colors: string[];
	onChange: (color: string) => void;
	className?: string;
};

const Swatches = (props: Props) => (
	<div className={cn(css.swatch, props.className)}>
		{props.colors.map(color => (
			<FillPreview
				key={`swatch-${color}`}
				className={css.swatchColor}
				value={color}
				onClick={() => props.onChange(color)}
			/>
		))}
	</div>
);

export default Swatches;
